
<template>
  <div>

  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  methods:{
    ...mapActions({
      setUser: 'User/setUser',
      setProfile: 'User/setProfile',
      clearOneUser: 'User/clearOneUser',
    })
  },
  mounted () {
    this.$auth.logout().then(() => {
      this.clearOneUser()
      this.$swal({
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
        title: 'Até mais',
        type: "success",
        confirmButtonText: 'OK',
        confirmButtonColor: '#003a3e',
      })
      this.$router.push('/')
    }).catch((error) => {
      console.log('error ' + error)
    });
  },
}
</script>

